/**
 * Advanced-Protection tab slugs, in tab-bar order.
 *
 * The active feature is kept in the URL (`?tab=<slug>`) so returning from a rule
 * form lands back on the feature the user was configuring, instead of resetting
 * to the first tab (Anti-Leech). Each slug equals that feature's rule-form route
 * segment (see WaapConsole routes), so a form returns with `?tab=<its segment>`.
 */
export const ADVANCED_TAB_SLUGS = [
  'anti-leech',
  'page-defacement',
  'csrf',
  'brute-force',
  'cc-protection',
  'xml-protection',
  'weak-password',
  'vulnerability-scanning',
  'honeypot',
  'cookie',
  'illegal-download',
] as const;

export type AdvancedTabSlug = (typeof ADVANCED_TAB_SLUGS)[number];

/** Resolve a `?tab=` slug to its tab index; unknown/missing → 0 (Anti-Leech). */
export function advancedTabIndex(slug: string | null): number {
  const i = ADVANCED_TAB_SLUGS.indexOf((slug ?? '') as AdvancedTabSlug);
  return i >= 0 ? i : 0;
}
